import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Sparkle } from '../Sparkle';
export function Rejoindre() {
  return <section className="bg-grege pb-20 md:pb-24" data-id="element-157" data-mp="1uu7buqti3hzu">
      <div className="mx-auto max-w-7xl px-6" data-id="element-158" data-mp="29q4zfkpcze0g">
        <div className="relative overflow-hidden rounded-3xl bg-nuit px-8 py-14 text-creme md:px-14" data-id="element-159" data-mp="29mr0ynjtfoya">
          <Sparkle className="pointer-events-none absolute -right-8 -top-10 h-56 w-56 opacity-25" color="#F2B134" data-id="element-160" data-mp="2ips54ip4f5zb" />
          <div className="relative max-w-2xl" data-id="element-161" data-mp="2dpxdue1foedq">
            <h2 className="font-display text-3xl font-bold sm:text-4xl" data-id="element-162" data-mp="2sflgbilcpj31">
              Chacun apporte sa lumière
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-creme/80" data-id="element-163" data-mp="2ng8hs0l4ankm">
              Adhérer, c’est 25 € par an : accès à toutes les activités, aux séances du ciné-club et
              aux coulisses des spectacles. Les bénévoles sont toujours les bienvenus, sur scène
              comme aux décors.
            </p>
            <div className="mt-8 flex flex-wrap gap-3" data-id="element-164" data-mp="bq437f33lty7">
              <Link to="/a-propos/contact" className="inline-flex items-center gap-2 rounded-full bg-soleil px-6 py-3 font-semibold text-nuit transition-colors duration-150 ease-out hover:bg-braise hover:text-white" data-id="element-165" data-mp="fqo48tqslhpm">
                Adhérer à l’association
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-166" data-mp="uo6njgkpb2po" />
              </Link>
              <Link to="/a-propos/contact" className="inline-flex items-center rounded-full border border-creme/30 px-6 py-3 font-semibold transition-colors duration-150 ease-out hover:border-soleil hover:text-soleil" data-id="element-167" data-mp="ypignw2sa62m">
                Poser une question
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}